<template>
    <v-layout column wrap>
        <v-flex>
            <v-form :data-vv-scope="formScope">
                <v-card>
                    <v-container grid-list-lg>
                        <v-layout pt-3 px-2 wrap>
                            <v-flex mb-3 px-2>
                                <div>
                                    <v-flex md3 px-2 sm6 xs12>
                                        <v-text-field :data-vv-as="$t('beneficiary-nationalNumJOR')"
                                                      :label="$t('beneficiary-nationalNumJOR') + ' *'"
                                                      :name="'beneficiaryNationalNumJOR'"
                                                      v-model="beneficiaryNationalNumJOR"
                                                      v-validate="'required|numeric'"
                                                      @change="nationalNumberChanged"
                                                      @keyup.enter="nationalNumberChanged"></v-text-field>
                                    </v-flex>
                                    <v-flex md3 px-2 sm6 xs12>
                                        <v-text-field :data-vv-as="$t('beneficiary-nationalNumJOR')"
                                                      :label="$t('full-name') + ' *'"
                                                      :name="'FULLNAE'"
                                                      v-model="FULLNAE"></v-text-field>
                                    </v-flex>

                                    <v-layout wrap pt-3 px-3>
                                        <v-layout class="outlined-box" pa-3 wrap>
                                            <label class="outlined-text bg-white">{{ $t('DiagonisisDetailsList') }}</label>
                                            <v-flex xs12>
                                                <v-data-table :loading="isLoading" :headers="headersDetails" :items="diagnosisDetailsInformationsList">
                                                    <template slot="items" slot-scope="props">
                                                        <tr :key="'PreviousDiagnosis' + props.index">
                                                            <td>{{ tableFormat('disabilityNaturesList', props.item.typeOfDisability) }}</td>
                                                            <td>{{ tableFormat2('diseasesList2', props.item.definitionOfDiseasesId)   }}</td>
                                                            <td>{{ tableFormat('disabilityDegreesList', props.item.degreeOfDisability) }}</td>
                                                            <td>{{ tableFormat('disabilityTypeList', props.item.natureOfDisability) }}</td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-layout>

                                    <v-expansion-panel class="panel" expand :value="panel">
                                        <v-expansion-panel-content class="p-bg-green">
                                            <template v-slot:header>
                                                <div>{{ $t('attachments') }}</div>
                                            </template>
                                            <template v-slot:actions>
                                                <v-icon color="white">mdi-chevron-down</v-icon>
                                            </template>
                                            <v-card>
                                                <v-layout pt-3 px-2 wrap>
                                                    <v-flex mb-3 px-2>
                                                        <v-layout class="outlined-box column" pa-3 wrap>
                                                            <label class="outlined-text bg-white">{{ $t('attachments') }}</label>

                                                            <v-layout v-if="files.length > 0" mb-3>
                                                                <files-viewer :files="files" />
                                                            </v-layout>
                                                            {{ $t('click-here') }}

                                                        </v-layout>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-card>
            </v-form>
        </v-flex>
    </v-layout>
</template>

<script>
    import DiagnosisDetailsInformationService from '@/services/Disabilities/PersonWithDisabilities/DiagnosisInformation/DiagnoseDetailsService';
    const BeneficiaryInformation = () => import('@/views/Disabilities/Shared/BeneficiaryInformation.vue');
    const FilesViewer = () => import('@/views/Directorate/Shared/FilesViewer.vue');
    import BeneficiaryInformationManagementService from '@/services/Disabilities/PersonWithDisabilities/BeneficiaryInformationManagement/BeneficiaryInformationManagement/BeneficiaryInformationManagementService';
    import PageService from '@/services/Archiving/InstancePageService';
    import DiagnosisInformationService from '@/services/Disabilities/PersonWithDisabilities/DiagnosisInformation/DiagnosisInformationService';
    import LookUpService from '@/services/LookUpService';
    import DefinitionOfDiseasesService from '@/services/Disabilities/PersonWithDisabilities/DefinitionOfDiseasesService';
    export default {
        name: 'beneficiary-information-details',
        data: () => ({
            beneficiaryInformationManagement: null,
            beneficiaryNationalNumJOR: '0',
            FULLNAE: '',
            isLoading: false,
            fileCategory: null, // current uploaded files category
            files: [], // Just For Preview On Init get files & save them in it
            uploadedList: [], // Saved Files In Uploader Weather Success or failed
            filesList: [], // Saved Success Files That Exist In Uploader
            fileCategoriesList: [], // to save files with its categories if all currect save categories in beneficiaryInformation and then save files
            treeId: 4,
            diagnosisDetailsInformationsList: [],
            disabilityNaturesList: [],
            diseasesList2: [],
            disabilityDegreesList: [],
            disabilityTypeList: [],
        }),
        created() {
            
        },
        methods: {
            async getDiseases() {
                this.diseasesList2 = (await DefinitionOfDiseasesService.getDefinitionOfDiseasesByCriteria()).data;
            }, 
             async getDisabilityDegrees() {
                this.disabilityDegreesList = (await LookUpService.getLookup(120)).data;
            },
            async getDisabilityNatures() {
                this.disabilityNaturesList = (await LookUpService.getLookup(112)).data;
            },
            async getDisabilityTypes() {
                this.disabilityTypeList = (await LookUpService.getLookup(53)).data;
            },
            async nationalNumberChanged() {
                this.beneficiaryInformationManagement = (await BeneficiaryInformationManagementService.getAllBeneficiaryInformationManagements({
                    keyword: '',
                    beneficiaryNationalNumJOR: this.beneficiaryNationalNumJOR
                })).data;

                this.FULLNAE = this.beneficiaryInformationManagement.getBeneficiaryInformationManagementDto.fullName;
                this.getUploadedFiles();
                this.getDisabilityNatures();
                this.getDiseases();
                this.getDisabilityDegrees();
                this.getDisabilityTypes(); 
                this.getDiagnosisInformations();
            },
            async getDiagnosisInformations() {
                this.diagnosisInformation = [];
                this.isLoading = true;
                var diagnosisInformation = (await DiagnosisInformationService.getDiagnosisInformations({
                    keyword: this.keyword,
                    beneficiaryNationalNumJOR: this.beneficiaryNationalNumJOR
                })).data;

                diagnosisInformation.forEach(element => {
                    this.getAllBeneficaryDiagnosisDetails(element.id);
                });
                this.isLoading = false;
            },
            async getAllBeneficaryDiagnosisDetails(id) {
                this.diagnosisDetailsInformationsList = (await DiagnosisDetailsInformationService.getDiagnoseDetailsByCriteria({
                    keyword: '',
                    diagonisisInformationId: id
                })).data;

                var lst = this.diagnosisDetailsInformationsList.filter(disability => disability.typeOfDisability !== '7');

                lst.forEach(element => {
                    this.diagnosisDetailsInformationsList.push({ element });
                });
                console.log(this.diagnosisDetailsInformationsList);
            },
            tableFormat(arrayName, code) {
                const item = this[arrayName].find(item => item.code === code);
                return item ? item.name : code;
            },
            tableFormat2(arrayName, code) {
                const item = this[arrayName].find(item => item.id === code);
                return item ? item.arName : code;
            },
            async getUploadedFiles() {
                this.files = [];
                var uploadedFilesList = (await PageService.getPages({
                    treeId: this.treeId,
                    instanceId: this.beneficiaryInformationManagement.getBeneficiaryInformationManagementDto.id,
                    keyWord: ''
                })).data;
                uploadedFilesList.forEach(element => {
                    this.files.push({
                        id: element.id,
                        url: element.path,
                        type: element.fileExtension,
                        fileCategoryId: element.fileCategoryId,
                        beneficiaryInformationId: this.beneficiaryInformationManagement.getBeneficiaryInformationManagementDto.id,
                        categoryName: element.arLabel
                    });
                });

                const diagnosisInformation = (await DiagnosisInformationService.getDiagnosisInformations({
                    keyword: '',
                    beneficiaryNationalNumJOR: this.beneficiaryNationalNumJOR
                })).data;

                for (let i = 0; i < diagnosisInformation.length; i++) {
                    uploadedFilesList = (await PageService.getPages({
                        treeId: 62,
                        instanceId: diagnosisInformation[i].id,
                        keyWord: ''
                    })).data;

                    uploadedFilesList.forEach(element => {
                        this.files.push({
                            id: element.id,
                            url: element.path,
                            type: element.fileExtension,
                            fileCategoryId: element.fileCategoryId,
                            beneficiaryInformationId: this.beneficiaryInformationManagement.getBeneficiaryInformationManagementDto.id,
                            categoryName: element.arLabel
                        });
                    });
                }
            },
        },
        computed: {
            headersDetails() {
                return [
                    {
                        text: this.$t('disability-type'),
                        value: 'typeOfDisability',
                        sortable: false
                    },
                    {
                        text: this.$t('disabilities-diagnosis'),
                        value: 'DefinitionOfDiseasesId',
                        sortable: false
                    },
                    {
                        text: this.$t('disability-degree'),
                        value: 'degreeOfDisability',
                        sortable: false
                    },
                    {
                        text: this.$t('disability-nature'),
                        value: 'natureOfDisability',
                        sortable: false
                    }
                ];
            },
        },
        components: {
            FilesViewer
        }
    };
</script>
